import { render } from "./appfooter.vue?vue&type=template&id=b8a149ae&scoped=true"
import script from "./appfooter.vue?vue&type=script&lang=js"
export * from "./appfooter.vue?vue&type=script&lang=js"

import "./appfooter.vue?vue&type=style&index=0&id=b8a149ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a149ae"]])

export default __exports__